import React, { useEffect, useState } from 'react';
import { UTILS } from '../../constants';
import axios from 'axios';
import { toast } from 'react-toastify';
import { format } from 'date-fns';
export const DateShow = ({ cardDetail, saveDate, fetchCards }) => {
  // console.log('asdasd', cardDetail);
  const [dateDetails, setDateDetails] = useState(null);
  const [isValid, setIsValid] = useState(false);
  const [isChecked, setIsChecked] = useState(
    cardDetail?.task_completed == 1 ? true : false
  );

  const normalizeDate = (date) => {
    // console.log("asdasd",cardDetail?.card?.due_date)
    const d = new Date(date);
    return new Date(d.getFullYear(), d.getMonth(), d.getDate());
  };
  const dd = new Date();
  const nowdate = new Date(dd.getFullYear(), dd.getMonth(), dd.getDate());
  const formatDate = (date) => format(date, 'MMM d');
  useEffect(() => {
    setDateDetails(cardDetail);
  }, [cardDetail]);

  const startDate = saveDate?.start_date || dateDetails?.start_date;
  const dueDate = saveDate?.due_date || dateDetails?.due_date;
  const hasValidDates = startDate || dueDate;

  // Handle checkbox change
  const handleCheckboxChange = async (event) => {
    const newCheckedState = event.target.checked;
    setIsChecked(newCheckedState == true ? 1 : 0);

    const data = new FormData();
    data.append('task_id', cardDetail?.id);
    data.append('task_completed', newCheckedState == true ? 1 : 0);

    const mainurl = `${UTILS.API_url}board/v1/board-list-cards/task-completed`;

    try {
      const response = await axios.post(mainurl, data, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('trelloToken')}`,
          'Content-Type': 'multipart/form-data',
        },
      });

      // console.log('Response:', response.data);
      if (response.data.success) {
        toast.success(response.data.success);
        // console.log('Success');
      }
    } catch (error) {
      toast.error('Error:', error);
      // console.error('Error:', error);
    }
  };

  // Handle block click
  const handleBlockClick = () => {
    if (hasValidDates && isChecked) {
      setIsValid((prev) => !prev); // Toggle valid state if checkbox is checked and dates are valid
    } else {
      // console.log('Either dates are invalid or checkbox is not checked');
    }
  };

  return (
    <div>
      {hasValidDates && (
        <div>
          <h5 className="labelHeading">Date</h5>
          <div className="dateLabelWrap" onClick={handleBlockClick}>
            <label className="customCheck">
              {!cardDetail?.deleted_at &&(
              <input
                type="checkbox"
                name="checkbox"
                checked={isChecked}
                onChange={handleCheckboxChange}
              />)}
              <div className="dateLabel">
                <span>
                  {startDate && `${startDate.split(' ')[0]} - `}
                  {dueDate && dueDate.split(' ')[0]}
                </span>

                {/* <span
                  className={`labelDesign ${
                    isChecked ? 'labelGreen' : ((nowdate >   normalizeDate(new Date(cardDetail?.due_date)))? 'labelRed':'labelYellow')
                  }`}
                >
                  {isChecked ? 'Completed' : ((nowdate >   normalizeDate(new Date(cardDetail?.card?.due_date)))? 'Overdue':'Pending')}
                </span> */}

                {isChecked ? (
                              <span className="labelDesign labelGreen">Completed </span>
                            ) : ( nowdate >   normalizeDate(new Date(cardDetail?.due_date))) ? (
                              <span className="labelDesign labelRed">Overdue </span>
                          ) : (
                              <span className="labelDesign labelYellow">Pending </span>
                          )}



                {/* <span className="labelDesign labelIsDone labelRed labelGreen">
                  Overdue
                </span> */}
              </div>
            </label>
          </div>
        </div>
      )}
    </div>
  );
};
